const ROLES = {
  User: 2022,
  Cafe: 1126,
  Admin: 1995,
};

export default ROLES;
